// Plan renovable, servido por /dashboard/subscription/catalogue. El backend decide qué
// puede renovar cada negocio: `kind` "catalogue" = PlanVersion del catálogo nuevo (`id` es
// el planVersionId); "legacy" = ServicePlan de un cliente legacy, que conserva su plan y su
// precio por 12 meses (`id` es el planId). `limits` con null por dimensión = ilimitado; una
// dimensión ausente no aplica (el plan legacy no limita usuarios).
const CataloguePlan = class {
    constructor(object) {
        if (object === undefined || object === null) {
            this.id = null
            this.code = null
            this.name = null
            this.price = null
            this.limits = null
            this.modules = []
            this.extras = []
            this.featured = false
            this.kind = 'catalogue'
            this.priceWithTax = null
        } else {
            this.id = object.id || null            // planVersionId
            this.code = object.code || null
            this.name = object.name || null
            this.price = (object.price === undefined || object.price === null) ? null : object.price
            this.limits = object.limits || null
            this.modules = object.modules || []
            // Extras "solo agregar": opciones añadibles no incluidas en el plan {id, name, price, modules}.
            this.extras = object.extras || []
            this.featured = !!object.featured
            this.kind = object.kind || 'catalogue'
            // Total con IVA calculado por el backend (una sola tarifa para la suscripción).
            this.priceWithTax = (object.priceWithTax === undefined || object.priceWithTax === null) ? null : object.priceWithTax
        }
    }

    // Campo con el que el backend identifica el plan al renovar.
    get renewalField() {
        return this.kind === 'legacy' ? 'planId' : 'planVersionId'
    }

    // Etiqueta de un límite: el número, o `unlimitedText` cuando es null (centinela de ilimitado).
    limitLabel(key, unlimitedText) {
        const v = this.limits ? this.limits[key] : undefined
        if (v === null || v === undefined) return unlimitedText || "Ilimitados"
        return v
    }
}

export default CataloguePlan
